import * as Expressions from '../expressions/index.js';
import { Utils } from '../Utils.js';
import parser from '../../generator/Parser.js';
parser.yy = {
    Expression: Expressions,
    Utils
};
export class OclParser {
    static parseQuery(oclExpression, registeredTypes) {
        parser.yy.registeredTypes = registeredTypes || {};
        return parser.parse(oclExpression);
    }
    static parse(oclExpression, labels = [], registeredTypes) {
        const packageDeclaration = OclParser.parseQuery(oclExpression, registeredTypes);
        packageDeclaration.setExecutionLabels(labels);
        packageDeclaration.setRawOclExpression(oclExpression);
        return packageDeclaration;
    }
    static setEnv(env) {
        parser.yy.env = env;
    }
    static _lex(oclExpression) {
        const lexer = parser.lexer;
        lexer.setInput(oclExpression);
        while (!lexer.done) {
            const token = lexer.lex();
            let resultingToken;
            if (token in parser.terminals_) {
                resultingToken = parser.terminals_[token];
            }
            console.log(`<${token}, ${lexer.yytext}>`);
        }
    }
}
OclParser.registeredTypes = {
    Array,
    Boolean,
    Function,
    Number,
    Object,
    String
};
OclParser.registeredEnums = {};
//# sourceMappingURL=OclParser.js.map